import { Flex, Text, useMantineTheme } from '@mantine/core';

import { PredefinedIcons } from '@dealstack/frontend/shared/components/fundament/Icon/Icon.types.ts';
import { Icon } from '@dealstack/frontend/shared/components/fundament/Icon';
import { InvestmentPlaceholderStyles } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/InvestmentDetails/components/InvestmentPlaceholder/InvestmentPlaceholder.styles.tsx';

interface Props {
	label: string;
	icon: PredefinedIcons;
	mih?: number;
}

export const InvestmentPlaceholder = ({ label, icon, mih = 168 }: Props) => {
	const theme = useMantineTheme();

	return (
		<InvestmentPlaceholderStyles>
			<Flex direction="column" justify="center" align="center" gap="0.5rem" mih={mih}>
				<div className="icon-container">
					<Icon
						variant={icon}
						size="vlg"
						color={theme.colors.gray[9]}
						fillStroke={true}
					/>
				</div>

				<Text c="dark.0">{label}</Text>
			</Flex>
		</InvestmentPlaceholderStyles>
	);
};
